const mutations = {
  SET_SETTLEMENTS(state, settlements) {
    state.settlements = settlements
  }
}

export default mutations
